<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="hero-section ptb-100" style="background:#00A69F">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                        <h1 class="text-white mb-0">Escuelas virtuales</h1>
                        <div class="custom-breadcrumb">
                            <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                                <li class="list-inline-item breadcrumb-item"><a href="#">Conoce más sobre cada curso e inscríbete.</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section style="margin-top:-40px">
        <div class="container card card-custom py-3 border-0 gray-light-bg shadow">
            <div class="row">
                <div class="col-sm-6">
                    <div class="text-cente">
                        <el-radio-group v-model="getCategoryId" @change="getListCourses">
                            <el-radio-button label="">Todas</el-radio-button>
                            <el-radio-button v-for="item in listCategories" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
                        </el-radio-group>
                    </div>
                </div>
                <div class="col-sm-6">
                    <el-input v-model="search" placeholder="Buscar..." prefix-icon="el-icon-search" clearable maxlength="30"></el-input>
                </div>
            </div>
        </div>
    </section>
    <section class="customer-review-section py-5">
        <div class="container">
            <div class="row" v-if="filteredData.length>0">
                <router-link v-for="course in filteredData" :key="course.idcourse" class="col-md-4 col-sm-4 col-lg-4" :to="'virtuales/'+course.slug">
                    <div class="card single-pricing-pack mb-5 card-custom">
                        <div v-if="course.tag>0" class="card-header-right ribbon ribbon-clip ribbon-left">
                            <div class="ribbon-target" style="top: 12px;">
                                <span :class="'ribbon-inner bg-'+course.tagClass"></span>{{course.tagName}}</div>
                        </div>
                        <span class="category position-absolute badge badge-pill badge-info" v-text="course.school"></span>
                        <div class="media author-info my-3">
                            <div class="author-img mx-3 mt-5">
                                <img :src="course.img" alt="client" class="img-fluid rounded-circle">
                            </div>
                            <div class="media-body">
                                <h5 class="mt-4 mb-0 title" v-text="course.title"></h5>
                                <span class="price font-weight-bolder" v-text="'S/ '+course.price"></span>
                            </div>
                        </div>
                        <div class="card-body text-center">
                            <p class="card-text" v-text="course.description"></p>
                            <router-link :key="course.idcourse" class="btn outline-btn mb-3" :to="'virtuales/'+course.slug">Más detalles</router-link>
                        </div>
                    </div>
                </router-link>
            </div>
            <div v-else id="notfound">
                <div class="notfound">
                    <div class="notfound-404">
                        <h1>:(</h1>
                    </div>
                    <h2>Lo sentimos</h2>
                    <p>No tenemos resultados para mostrar de acuerdo a la busqueda realizada, intenta con otra palabra.</p>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    data() {
        return {
            fullscreenLoading: false,
            search: '',
            listCourses: [],
            listCategories: [],
            getCategoryId: '',
            getCategorySlug: '',
            tbTemporal: [],
        }
    },
    computed: {
        filteredData: function () {
            this.tbTemporal = this.listCourses;
            return this.tbTemporal.filter(data => !this.search || data.title.toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods: {
        getListCategories() {
          try {
            this.fullscreenLoading = true;
            axios.post(`${process.env.API1}/virtual/category`).then(response => {
                this.listCategories = response.data;
                this.fullscreenLoading = false;
                if (this.$route.query.category != undefined) {
                    this.listCategories.forEach(element => {
                        if (this.$route.query.category == element.slug) {
                            this.getCategoryId = element.id;
                            return;
                        }
                    });
                } else {
                    this.getCategoryId = '';
                }
                this.getListCourses();
            });
          } catch (error) {
            this.fullscreenLoading = false;
          }
        },
        getListCourses() {
            try {
                if (this.$route.query.category != undefined) {
                    this.listCategories.forEach(element => {
                        if (this.getCategoryId == element.id) {
                            this.getCategorySlug = element.slug;
                            return;
                        }
                    });
                    history.pushState(null, "", "/escuelas/virtuales?category=" + this.getCategorySlug);
                }
                if (this.getCategoryId == '') {
                    history.pushState(null, "", "/escuelas/virtuales");
                }
                this.search = '';
                this.fullscreenLoading = true;
                var formdata = new FormData();
                formdata.append('category', this.getCategoryId);
                axios.post(`${process.env.API1}/virtual`, formdata).then(response => {
                    this.listCourses = response.data;
                    this.fullscreenLoading = false;
                });
            } catch (error) {
                this.fullscreenLoading = false;
            }
        },
    },
    created() {
        this.getListCategories();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/evirtual/Index.vue